<template>
<div class="chapter">
<div class="inner_page">
<p class="title_tp">WINSTON S. CHURCHILL</p>
<p class="author"><span class="author_byline">b<span class="small">y</span></span> M<span class="small">ARTIN</span> G<span class="small">ILBERT</span></p>
<p class="subtitle">V<span class="small">OLUME</span> IV</p>
<p class="subtitle_main">W<span class="small">ORLD</span> <span class="small">IN</span> T<span class="small">ORMENT</span></p>
<p class="subtitle_tp">1916–1922</p>
<p class="publisher">Hillsdale College Press</p>
<p class="publisher1">RosettaBooks</p>
<p class="publisher1">2015</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?a6c15836